import ImageWMS from 'ol/source/ImageWMS.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import {Image as ImageLayer} from 'ol/layer.js';
import { Projection, get as getProjection } from 'ol/proj.js';
import MultiPolygon from 'ol/geom/MultiPolygon.js';
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';

var dtselect = document.getElementById("district-select");
var thselect = document.getElementById("taluka-select");
var vlselect = document.getElementById("village-select");
var wselect = document.getElementById("ws-select");
var yselect = document.getElementById("year-select");
var cropselect = document.getElementById("crop-select");
var soilselect = document.getElementById("soil-select");
var ccaselect = document.getElementById("cca-select");

var URI_VWB = "34.131.193.102/iitbvwb"
//var URI_VWB = "127.0.0.1:5000"
var URI_GS = "34.131.193.102:8080/geoserver"

// GeoServer layer names whose features lying within the chosen GP
// boundary will be shown.
const layerNamesForGP = [
    "gpboundary", "agriland_in_gp", "secondary_ccas", "primary_structures",
    "secondary_structures", "habitation"];

// GeoServer layer names to be shown as base layers.
const baseLayerNames = [
    "stream", "contour"
];

// GeoServer specific Source object dictionary, keyed by layer names.
var mapSources = {}

// District bounds, used to zoom the map to selected district.
var districts = {};
var districtsList = [];
var talukas = {};
var talukasList = {};
var vincodes = {};
var vincodesList = {};
var majorws = {};

// Key = major watershed ID.  Value is a list of dicts, where each
// dict is of the form
//   {
//       "texture": ...,
//       "soildepth_cm": ...,
//       "soildepth_pretty": ...
//   }
var soils = {};

resetSelect("district-select");
resetSelect("taluka-select");
resetSelect("village-select");
resetSelect("ws-select");
resetSelect("soil-select");
resetSelect("cca-select");

async function getCropSequences() {
    const url = new URL("http://"+URI_VWB+"/cropseq");
    console.info(url.href);
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const cseq = await response.json();
    if (cseq.numberReturned <= 0) {
        throw new Error("no crop sequence returned, url: "+url);
    }
    cseq["cropseq"].forEach(function (cs) {
        var option = document.createElement("option");
        option.value = cs["id"]
        option.text = cs["label"];
        cropselect.appendChild(option);
    });
}

async function getDistricts() {
    const url = new URL("http://"+URI_VWB+"/districts");
    console.info("getting districts: " + url.href);
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const finfo = await response.json();
    if (finfo.numberReturned <= 0) {
        throw new Error("no district returned, url: "+url);
    }
    console.info("got districts");
    finfo["districts"].forEach(function (district) {
        var districtName = district["name_hindi"];
        var dtncode = district["censuscode"];
        vincodes[dtncode] = {};
        vincodesList[dtncode] = {};
        var dtextent = [
            district['xmin'],
            district['ymin'],
            district['xmax'],
            district['ymax']
        ];
        districts[dtncode] = dtextent;
        districtsList.push(districtName.toLowerCase());
        var option = document.createElement("option");
        option.value = dtncode;
        option.text = districtName;
        dtselect.appendChild(option);
    });
}

async function getTalukas(dtncode, talukasList) {
    if (!talukasList[dtncode]) {
        const url = new URL("http://"+URI_VWB+"/talukas");
        url.searchParams.append("dtcode", dtncode);
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const finfo = await response.json();
        if (finfo.numberReturned <= 0) {
            throw new Error("no talukas returned, url: "+url);
        }
        talukas[dtncode] = {};
        talukasList[dtncode] = [];
        finfo["talukas"].forEach(taluka => {
            var talukaName = taluka['name_hindi'];
            var thncode = taluka['censuscode'];
            var thextent = [
                taluka['xmin'],
                taluka['ymin'],
                taluka['xmax'],
                taluka['ymax']
            ]
            talukas[dtncode][thncode] = thextent;
            talukasList[dtncode].push([talukaName, thncode]);
        });
    }
    talukasList[dtncode].forEach(taluka => {
        var option = document.createElement("option");
        option.value = taluka[1];
        option.text = taluka[0];
        thselect.appendChild(option);
    })
}

async function getVincodes(dtncode, thncode, vincodesList) {
    if (!vincodesList[dtncode][thncode]) {
        const url = new URL(
            "http://"+URI_VWB+"/villages")
        url.searchParams.append("thcode", thncode);
        console.info("fetching GPs for tehsil code "+thncode);
        console.info(url.href);
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const finfo = await response.json();
        if (finfo.numberReturned <= 0) {
            throw new Error("no GPs found, url: "+url);
        }
        vincodes[dtncode][thncode] = {};
        vincodesList[dtncode][thncode] = [];
        finfo["villages"].forEach(village => {
            var vincode = village['id'];
            var vlname = village['name_hindi'];
            var vlextent = [
                village['xmin'],
                village['ymin'],
                village['xmax'],
                village['ymax']
            ]
            vincodes[dtncode][thncode][vincode] = {
		"extent": vlextent,
		"pmis_gpid": village["pmis_gpid"]
	    }
            vincodesList[dtncode][thncode].push([vlname, vincode]);
        });
    }
    vincodesList[dtncode][thncode].forEach(village => {
        var option = document.createElement("option");
        option.value = village[1];
        option.text = village[0];
        vlselect.appendChild(option);
    })
}

async function getMajorWS(vincode) {
    const url = new URL("http://"+URI_VWB+"/majorws");
    url.searchParams.append("gpid", vincode);
    console.info("getting major watersheds for " + vincode + ": " + url.href);
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const finfo = await response.json();
    if (finfo.numberReturned <= 0) {
        throw new Error("no major watersheds found, url: "+url);
    }
    console.info("got watersheds");
    finfo["majorws"].forEach(function (ws) {
        var wsname = ws["name_hindi"];
        var hectare = ws["area_ha"];
        var wsid = ws["id"];
        var option = document.createElement("option");
        option.value = wsid;
        option.text = wsname + " (" + hectare +" ha)";
        wselect.appendChild(option);
	majorws[wsid] = ws["description"];
    });
}

async function soiltypes(gpid, gpname) {
    var url = new URL("http://"+URI_VWB+"/soiltypes")
    url.searchParams.append("gpid", gpid);
    console.info(url.href);
    var response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    var sjson = await response.json();
    var stypes = sjson["soiltypes"];
    console.info("got " + stypes.length + " soil types in GP " + gpname);
    if (stypes.length > 0) {
        stypes.forEach(function(s, i) {
            var texture = s["texture"]
            var depthcm = s["soildepth_cm"]
            var option = document.createElement("option");
            option.value = i;
            option.text = texture + ", " + s["soildepth_pretty"];
            soilselect.appendChild(option);
        });
        soils[gpid] = stypes;
        document.getElementById("plottitle").innerHTML =
            "Select a crop pair and soil type in GP " + gpname +
            " to generate plot";
    }
    else {
        document.getElementById("plottitle").innerHTML =
            "No agricultural land in GP " + gpname;
    }
}

const landusesummary = async (mwsid) => {
    var url = new URL("http://"+URI_VWB+"/mwslanduse")
    url.searchParams.append("mwsid", mwsid);
    console.info(url.href);
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const landuse = await response.json();
    if (landuse.numberReturned <= 0) {
        throw new Error("no land use summary, url: "+url);
    }
    console.log(landuse)
    landusetable(landuse["landuse"]);
}

const toposummary = async (mwsid) => {
    var url = new URL("http://"+URI_VWB+"/mwstopography")
    url.searchParams.append("mwsid", mwsid);
    console.info(url.href);
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const topo = await response.json();
    if (topo.numberReturned <= 0) {
        throw new Error("no topography summary, url: "+url);
    }
    console.log(topo)
    topotable(topo["topography"]);
}

const lithosoilsummary = async (mwsid) => {
    var url = new URL("http://"+URI_VWB+"/mwslithosoil")
    url.searchParams.append("mwsid", mwsid);
    console.info(url.href);
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const lithosoil = await response.json();
    if (lithosoil.numberReturned <= 0) {
        throw new Error("no lithology and soil summary, url: "+url);
    }
    console.log(lithosoil)
    lithosoiltable(lithosoil["lithosoil"]);
}

// Fetch monsoon and post-monsoon water budget in parallel
const majorwswb = async (vincode, year, mwsid) => {
    var url1 = new URL("http://"+URI_VWB+"/monsoonwb")
    url1.searchParams.append("gpid", vincode);
    url1.searchParams.append("year", year);
    url1.searchParams.append("mwsid", mwsid);
    console.info(url1.href);
    var url2 = new URL("http://"+URI_VWB+"/postmonsoonwb")
    url2.searchParams.append("gpid", vincode);
    url2.searchParams.append("year", year);
    url2.searchParams.append("mwsid", mwsid);
    console.info(url2.href);
    const responsesJSON = await Promise.all([fetch(url1), fetch(url2)]);
    const [monsoonres, postmonsoonres] = await Promise.all(
        responsesJSON.map(r => r.json()));
    console.log(monsoonres, "monsoon");
    console.log(postmonsoonres, "post monsoon");
    const monsoonwb = monsoonres["monsoonwb"][0];
    const postmonwb = postmonsoonres["postmonwb"]
    tableFromJSON(monsoonwb, postmonwb, "mwbtable");
    console.log(document.getElementById("vwb").innerHTML);
}

async function showbaseflowplot(mwsid, year) {
    var url = new URL("http://"+URI_VWB+"/baseflowplot")
    url.searchParams.append("year", year);
    url.searchParams.append("mwsid", mwsid);
    console.info(url.href);
    document.getElementById("baseflowplot").src = url.href
}

async function showcropplot(vincode, cropseq, texture, depthcm, year) {
    var url = new URL("http://"+URI_VWB+"/cropplot")
    url.searchParams.append("gpid", vincode);
    url.searchParams.append("year", year);
    url.searchParams.append("cropseq", cropseq);
    url.searchParams.append("texture", texture);
    url.searchParams.append("soildepth_cm", depthcm);
    console.info(url.href);
    document.getElementById("plot").src = url.href

    url = new URL("http://"+URI_VWB+"/cropplotsummary")
    url.searchParams.append("gpid", vincode);
    url.searchParams.append("year", year);
    url.searchParams.append("cropseq", cropseq);
    url.searchParams.append("texture", texture);
    url.searchParams.append("soildepth_cm", depthcm);
    var response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    var cropsummaryjson = await response.json();
    console.info(cropsummaryjson);
    tableFromCropSummary(cropsummaryjson)
}

function tableFromCropSummary(cpsummary) {
    var header = `
            <tr>
              <th>Crop</th>
              <th>Sowing date</th>
              <th>Harvest date</th>
              <th>Total demand (mm)</th>
              <th>Demand satisfied through rain (mm)</th>
              <th>Irrigation demand as percent of total demand</th>
            </tr>`;
    let oldtable = document.getElementById("cptable");
    if (oldtable) {
        oldtable.innerHTML = "";
    }
    let table = document.getElementById("cptable");
    let tbody = document.createElement("tbody");
    tbody.innerHTML = header;
    var crops = cpsummary["cropsummary"];
    crops.sort(function(a, b) {
	return a["order"] - b["order"];
    });
    crops.forEach(cropinfo => {
        let tr = tbody.insertRow(-1);
        // insert new cell at the end of current row
        let cell = tr.insertCell(-1);
        cell.innerHTML = cropinfo["cropname"];
        cell.setAttribute("class", "mwbtcell");
        cell = tr.insertCell(-1);
        cell.setAttribute("class", "mwbtcell");
        cell.innerHTML = cropinfo["sowing_date"];
        cell = tr.insertCell(-1);
        cell.setAttribute("class", "mwbtcell");
        cell.innerHTML = cropinfo["harvest_date"];
        cell = tr.insertCell(-1);
        cell.setAttribute("class", "mwbtcell");
        cell.innerHTML = cropinfo["pet"];
        cell = tr.insertCell(-1);
        cell.setAttribute("class", "mwbtcell");
        cell.innerHTML = cropinfo["aet"];
        cell = tr.insertCell(-1);
        cell.setAttribute("class", "mwbtcell");
        cell.innerHTML = cropinfo["percent_deficit"] + "%";
    })
    table.appendChild(tbody);
    table.setAttribute("border", "1");
    return table;
}

function landusetable(landusesummary) {
    var header = `
            <tr>
              <th>Dense forest (%)</th>
              <th>Sparse forest (%)</th>
              <th>Grassland / scrubland (%)</th>
              <th>Agriculture crops (%)</th>
              <th>Horticulture plantation (%)</th>
            </tr>`;
    let oldtable = document.getElementById("landusetable");
    if (oldtable) {
        oldtable.innerHTML = "";
    }
    let table = document.getElementById("landusetable");
    let tbody = document.createElement("tbody");
    tbody.innerHTML = header;
    let tr = tbody.insertRow(-1);
    // insert new cell at the end of current row
    let cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell");
    cell.innerHTML = landusesummary["dense_forest_percent"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell");
    cell.innerHTML = landusesummary["sparse_forest_percent"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell");
    cell.innerHTML = landusesummary["grass_scrub_percent"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell");
    cell.innerHTML = landusesummary["agri_area_percent"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell");
    cell.innerHTML = landusesummary["agri_plantation_percent"];
    table.appendChild(tbody);
    table.setAttribute("border", "1");
    return table;
}

function topotable(toposummary) {
    var header = `
            <tr>
              <th>Minimum elevation<br />(m asl)</th>
              <th>Maximum elevation<br />(m asl)</th>
              <th>Gentle slope area (%)</th>
              <th>Moderate slope area (%)</th>
              <th>Steep slope area (%)</th>
            </tr>`;
    let oldtable = document.getElementById("topotable");
    if (oldtable) {
        oldtable.innerHTML = "";
    }
    let table = document.getElementById("topotable");
    let tbody = document.createElement("tbody");
    tbody.innerHTML = header;
    let tr = tbody.insertRow(-1);
    // insert new cell at the end of current row
    let cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell");
    cell.innerHTML = toposummary["elev_min"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell");
    cell.innerHTML = toposummary["elev_max"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell");
    cell.innerHTML = toposummary["gentle_slope_percent"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell");
    cell.innerHTML = toposummary["moderate_slope_percent"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell");
    cell.innerHTML = toposummary["steep_slope_percent"];
    table.appendChild(tbody);
    table.setAttribute("border", "1");
    return table;
}

function lithosoiltable(lithosoil) {
    var header = `
            <tr>
              <th>Dominant soil group</th>
              <th>Soil storage capacity</th>
              <th>Soil hydraulic conductivity</th>
              <th>Domniant aquifer group</th>
              <th>Aquifer storativity</th>
              <th>Aquifer hydraulic conductivity</th>
            </tr>`;
    let oldtable = document.getElementById("lithosoiltable");
    if (oldtable) {
        oldtable.innerHTML = "";
    }
    let table = document.getElementById("lithosoiltable");
    let tbody = document.createElement("tbody");
    tbody.innerHTML = header;
    let tr = tbody.insertRow(-1);
    // insert new cell at the end of current row
    let cell = tr.insertCell(-1);
    cell.setAttribute("class", "centercell");
    cell.innerHTML = lithosoil["dominant_soil"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "centercell");
    cell.innerHTML = lithosoil["soil_storage_capacity"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "centercell");
    cell.innerHTML = lithosoil["soil_conductivity"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "centercell");
    cell.innerHTML = lithosoil["dominant_litho_group"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "centercell");
    cell.innerHTML = lithosoil["aquifer_storativity"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "centercell");
    cell.innerHTML = lithosoil["aquifer_conductivity"];
    table.appendChild(tbody);
    table.setAttribute("border", "1");
    return table;
}

getDistricts();
getCropSequences();

function createImageSource(workspace, layername, filterparams, viewparams) {
    var imgsrcparams = {
        'FORMAT': 'image/png',
        'VERSION': '1.1.1',
        "STYLES": '',
        "LAYERS": workspace + ":" + layername,
        "exceptions": 'application/vnd.ogc.se_inimage',
    };
    if (filterparams) {
        imgsrcparams["CQL_FILTER"] = filterparams["CQL_FILTER"];
    }
    if (viewparams) {
        imgsrcparams["VIEWPARAMS"] = viewparams["VIEWPARAMS"];
    }
    return new ImageWMS({
        ratio: 1,
        url: 'http://'+URI_GS+'/'+workspace+'/wms',
        params: imgsrcparams,
        serverType: 'geoserver',
    });
}

function updateLegend(resolution) {
    const layersArray = map.getLayers().getArray();
    const layersIterable = layersArray.slice();
    layersIterable.forEach(layer => {
	const source = layer.getSource();
	if (source instanceof ImageWMS) {
	    var graphicUrl = layer.getSource().getLegendUrl(
		resolution,
		{"LEGEND_OPTIONS": "forceTitles:off;forceLabels:on"}
	    );
	    console.log("legend: " + graphicUrl);
	}
    })
}

var map = new Map({
    target: 'map',
    view: new View({
	projection: getProjection("EPSG:4326")
    })
});

function resetSelect(id) {
    var select = document.getElementById(id);
    while(select.firstChild) {
        select.removeChild(select.firstChild);
    }
    var option = document.createElement("option");
    option.value = "";
    option.text = "--Unselected--";
    select.appendChild(option);
    // TODO: move this to a separate function.
    document.getElementById("mwbtable").innerHTML = "<tbody></tbody>";
    document.getElementById("cptable").innerHTML = "<tbody></tbody>";
    document.getElementById("landusetable").innerHTML = "<tbody></tbody>";
    document.getElementById("topotable").innerHTML = "<tbody></tbody>";
    document.getElementById("lithosoiltable").innerHTML = "<tbody></tbody>";
    document.getElementById("wbtitle").innerHTML =
        "Select a watershed and year for more details";
    document.getElementById("wsdescription").innerHTML = "";
    document.getElementById("landusetitle").innerHTML = "";
    document.getElementById("lithosoiltitle").innerHTML = "";
    document.getElementById("topotitle").innerHTML = "";
    document.getElementById("plottitle").innerHTML =
        "Select crop pair and soil type to generate crop water stress plot";
    document.getElementById("plot").src = "";
}

/*
  Render a map comprising of GP specific and base layers.
 */
function setMap(gpid, extent) {
    // Remove existing layers
    const layersArray = map.getLayers().getArray();
    console.info("number of layers: " + layersArray.length);
    const layersToRemove = layersArray.slice();
    layersToRemove.forEach(layer => {
        map.removeLayer(layer);
    });
    var mapsource;
    // Add base layers to the map first
    map.addLayer(new TileLayer({source: new OSM()}));
    baseLayerNames.forEach(layername => {
	console.info("base layer: " + layername);
	mapsource = createImageSource("hpidp", layername, null, null);
	map.addLayer(new ImageLayer({source: mapsource}));
    })
    // Then add GP specific layers
    const params = {"VIEWPARAMS": "gpid:" + gpid};
    layerNamesForGP.forEach(layername => {
	console.info("gp spcecific layer: " + layername);
	mapsource = createImageSource("hpidp", layername, null, params);
        map.addLayer(new ImageLayer({source: mapsource}));
    })
    // Trigger rendering of the map constructed above
    var resolution = map.getView().getResolution();
    updateLegend(resolution);
    map.getView().fit(extent, map.getSize());
    map.setTarget("map");
}

function showWatershed(wsid, gpid, extent) {
    // Remove existing layers
    const layersArray = map.getLayers().getArray();
    console.info("number of layers: " + layersArray.length);
    const layersToRemove = layersArray.slice();
    layersToRemove.forEach(layer => {
        map.removeLayer(layer);
    });
    var mapsource;
    // Add base layers to the map first
    map.addLayer(new TileLayer({source: new OSM()}));
    baseLayerNames.forEach(layername => {
	console.info("base layer: " + layername);
	mapsource = createImageSource("hpidp", layername, null, null);
	map.addLayer(new ImageLayer({source: mapsource}));
    })
    // Then add GP specific layers
    var params = {"VIEWPARAMS": "gpid:" + gpid};
    layerNamesForGP.forEach(layername => {
	console.info("gp spcecific layer: " + layername);
	mapsource = createImageSource("hpidp", layername, null, params);
        map.addLayer(new ImageLayer({source: mapsource}));
    })
    params = {"VIEWPARAMS": "point_id:" + wsid};
    mapsource = createImageSource("hpidp", "primary_watershed", null, params);
    map.addLayer(new ImageLayer({source: mapsource}));
    // Trigger rendering of the map constructed above
    var resolution = map.getView().getResolution();
    updateLegend(resolution);
    map.getView().fit(extent, map.getSize());
    map.setTarget("map");
}

function districtRoutine() {
    var dtncode = dtselect.options[dtselect.options.selectedIndex].value;
    resetSelect("taluka-select");
    resetSelect('village-select');
    resetSelect('ws-select');
    resetSelect("soil-select");
    getTalukas(dtncode, talukasList);
}

function talukaRoutine() {
    var dtncode = dtselect.options[dtselect.options.selectedIndex].value;
    var thncode = thselect.options[thselect.options.selectedIndex].value;
    resetSelect('village-select');
    resetSelect('ws-select');
    resetSelect("soil-select");
    getVincodes(dtncode, thncode, vincodesList);
}


function tableFromJSON(monwbdict, postmonwbdict, tid) {
    var header = `
            <tr>
              <th>Season</th>
              <th>Rain (mm)</th>
              <th>Runoff (mm)</th>
              <th>AET (mm)</th>
              <th>PET (mm)</th>
              <th>Groundwater recharge (mm)</th>
              <th>Available soil moisture (mm)</th>
            </tr>`;
    let oldtable = document.getElementById(tid);
    if (oldtable) {
        oldtable.innerHTML = "";
    }
    let table = document.getElementById(tid);
    let tbody = document.createElement("tbody");
    tbody.innerHTML = header;
    // monsoon water budget
    let tr = tbody.insertRow(-1);
    // insert new cell at the end of current row
    let cell = tr.insertCell(-1);
    cell.innerHTML = monwbdict["season"] + ":<br />" +
        monwbdict["from_date"] + " to<br />" + monwbdict["to_date"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = monwbdict["rain"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = monwbdict["runoff"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = monwbdict["aet"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = monwbdict["pet"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = monwbdict["gw_recharge"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = monwbdict["avail_sm"];

    // post monsoon water budget
    tr = tbody.insertRow(-1);
    cell = tr.insertCell(-1);
    cell.innerHTML = postmonwbdict["season"] + ":<br />" +
        postmonwbdict["from_date"] + " to<br />" + postmonwbdict["to_date"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = postmonwbdict["rain"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = postmonwbdict["runoff"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = postmonwbdict["aet"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = postmonwbdict["pet"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = postmonwbdict["gw_recharge"];
    cell = tr.insertCell(-1);
    cell.setAttribute("class", "mwbtcell")
    cell.innerHTML = postmonwbdict["avail_sm"];

    table.appendChild(tbody);
    table.setAttribute("border", "1");
    return table;
}

function showCCA() {
    var secondary_id = ccaselect.options[ccaselect.options.selectedIndex].value;
    var dtncode = dtselect.options[dtselect.options.selectedIndex].value;
    var thncode = thselect.options[thselect.options.selectedIndex].value;
    var vincode = vlselect.options[vlselect.options.selectedIndex].value;
    var cca = vincodes[dtncode][thncode][vincode]["ccainfo"][secondary_id];
    let ccatable_old = document.getElementById("cca-table");
    if (ccatable_old) {
        ccatable_old.innerHTML = "";
    }
    let ccatable = document.getElementById("cca-table");
    let tbody = document.createElement("tbody");
    tbody.innerHTML = `
            <tr>
              <th>Gram Panchayat</th>
              <th>Secondary structure location</th>
              <th>Activity Description</th>
              <th>Command area (sqm)</th>
              <th>Linked primary structure location</th>
              <th>Primary gram panchayat</th>
            </tr>`;

    let tr = tbody.insertRow(-1);
    // insert new cell at the end of current row
    let cell = tr.insertCell(-1);
    cell.innerHTML = cca["secondary_name_of_village"];
    cell = tr.insertCell(-1);
    cell.innerHTML = cca["secondary_location"];
    cell = tr.insertCell(-1);
    cell.innerHTML = cca["secondary_id"] + ": " + cca["secondary_activity_desc"]
    cell = tr.insertCell(-1);
    cell.innerHTML = cca["cca_area_sqm"]
    cell = tr.insertCell(-1);
    if (cca["secondary_primary_is_linked"] > 0) {
	cell.innerHTML = cca["primary_id"] + ": " + cca["primary_location"]
	cell = tr.insertCell(-1);
	cell.innerHTML = cca["primary_name_of_village"]
    }
    else {
	cell.innerHTML = "Not linked with a primary structure";
    }
    ccatable.appendChild(tbody);
    ccatable.setAttribute("border", "1");
}

async function secondaryCCA(vincode) {
    const url = new URL("http://"+URI_VWB+"/datarequest");
    console.info(url.href);
    var dtncode = dtselect.options[dtselect.options.selectedIndex].value;
    var thncode = thselect.options[thselect.options.selectedIndex].value;
    let datareq = new FormData()
    datareq.append("function_name", "secondary_cca_info_json")
    datareq.append("args", JSON.stringify({
	"village_code": vincodes[dtncode][thncode][vincode]["pmis_gpid"]
    }))
    const response = await fetch(
	url, {method: 'POST', body: datareq});
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    var ccainfo = {};
    const ccalist = await response.json();
    /*
     * The backend's SQL function returns an array, which is further
     * encapsulated by Python route as an array (cursor.fetchall()).
     * The actual list of CCAs is two levels down.
     */
    console.log("ccalist.length: " + ccalist.length)
    if (ccalist.length > 0 && ccalist[0] !== null) {
	console.log("ccalist[0].length: " + ccalist[0].length)
	if (ccalist[0].length > 0 && ccalist[0][0] !== null) {
	    console.log("ccalist[0][0].length: " + ccalist[0][0].length)
	    ccalist[0][0].forEach(function (cca) {
		var sid = cca["secondary_id"];
		ccainfo[sid] = cca;
		var option = document.createElement("option");
		option.value = sid;
		option.text = sid + ": " + cca["secondary_location"];
		ccaselect.appendChild(option);
	    });
	    vincodes[dtncode][thncode][vincode]["ccainfo"] = ccainfo
	}
    }
}

function initCCA(vincode, vlname) {
    resetSelect("cca-select");
    document.getElementById("cca-table").innerHTML = "<tbody></tbody>";
    secondaryCCA(vincode);
}

function mapForVillage() {
    var vincode = vlselect.options[vlselect.options.selectedIndex].value;
    resetSelect("ws-select");
    resetSelect("soil-select");
    getMajorWS(vincode);
    var dtncode = dtselect.options[dtselect.options.selectedIndex].value;
    var dtname = dtselect.options[
	dtselect.options.selectedIndex].text.toLowerCase();
    var thncode = thselect.options[thselect.options.selectedIndex].value;
    var thname = thselect.options[
	thselect.options.selectedIndex].text.toLowerCase();
    var vlname = vlselect.options[vlselect.options.selectedIndex].text;
    if (dtncode == "" || thncode == "" || vincode == "")
        return;

    initCCA(vincode, vlname);
    setMap(vincode, vincodes[dtncode][thncode][vincode]["extent"]);
    // Soil types in the gram panchayat's agriculture land.  Used to
    // generate AET/PET plots for a crop sequence.
    soiltypes(vincode, vlname);
}

function gpwaterbudget() {
    var vincode = vlselect.options[vlselect.options.selectedIndex].value;
    var mwsid = wselect.options[wselect.options.selectedIndex].value;
    var year = yselect.options[yselect.options.selectedIndex].value;
    var dtncode = dtselect.options[dtselect.options.selectedIndex].value;
    var thncode = thselect.options[thselect.options.selectedIndex].value;
    if (mwsid !== null) {
	showWatershed(mwsid, vincode, vincodes[dtncode][thncode][vincode]["extent"])
	document.getElementById("wsdescription")
    }
    console.info(
        "fetching " + year + " waterbudget for watershed " + mwsid +
	    " in GP " + vincode);

    var vlname = vlselect.options[vlselect.options.selectedIndex].text;
    var wsname = wselect.options[wselect.options.selectedIndex].text;
    landusesummary(mwsid);
    var landusetitle = document.getElementById("landusetitle");
    landusetitle.innerHTML = "Land use by area percent in watershed " + wsname;
    toposummary(mwsid);
    var topotitle = document.getElementById("topotitle");
    topotitle.innerHTML = "Topography in watershed " + wsname;
    lithosoilsummary(mwsid);
    var topotitle = document.getElementById("lithosoiltitle");
    topotitle.innerHTML = "Lithology and soil in watershed " +
	wsname;
    majorwswb(vincode, year, mwsid);
    var wbtitle = document.getElementById("wbtitle");
    wbtitle.innerHTML = "Water budget for watershed " + wsname;
    var wsdesc = document.getElementById("wsdescription");
    if (majorws[mwsid] !== null) {
	wsdesc.innerHTML = "PWHS activity: " + majorws[mwsid];
    }
    var vwbdiv = document.getElementById("vwb");
    vwbdiv.removeAttribute("hidden");
    showbaseflowplot(mwsid, year);
}

function cropplot() {
    var vincode = vlselect.options[vlselect.options.selectedIndex].value;
    var year = yselect.options[yselect.options.selectedIndex].value;
    if (vincode && year) {
        var cropseq = cropselect.options[
	    cropselect.options.selectedIndex].value;
        var soilindex = soilselect.options[
	    soilselect.options.selectedIndex].value;
        var texture = soils[vincode][soilindex]["texture"];
        var depthcm = soils[vincode][soilindex]["soildepth_cm"];
        console.info("fetching plots for cropseq "+cropseq+" on "+
                     texture+", "+ depthcm+"cm in GP " + vincode);
        showcropplot(vincode, cropseq, texture, depthcm, year);
    }
    else {
        console.info("GP or year not selected, cannot fetch crop plot");
    }
}

dtselect.addEventListener('change', districtRoutine);
thselect.addEventListener('change', talukaRoutine);
vlselect.addEventListener('change', mapForVillage);
wselect.addEventListener('change', gpwaterbudget);
yselect.addEventListener('change', gpwaterbudget);
cropselect.addEventListener('change', cropplot);
soilselect.addEventListener('change', cropplot);
ccaselect.addEventListener('change', showCCA);
